import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { IActiveDate, IDatepickerTheme, NgPersianDatepickerModule } from 'ng-persian-datepicker';

// const customTheme: Partial<IDatepickerTheme> = {
//   selectedBackground: '#D68E3A',
//   selectedText: '#FFFFFF',
// };

@Component({
  selector: 'app-persian-date-picker',
  standalone: true,
  imports: [NgPersianDatepickerModule, ReactiveFormsModule,],
  templateUrl: './persian-date-picker.component.html',
  styleUrl: './persian-date-picker.component.css'
})
export class PersianDatePickerComponent {

  dateValue = new FormControl();

  @Output() dateSelected = new EventEmitter<string>();

  onDateChange(event: any) {
    this.dateSelected.emit(event); // Adjust according to the library output
  }

  onSelect(event: IActiveDate): void {
    const selectedTime = event;
    const viaTimestampValue = event.timestamp;
    const viaGregorianDate = new Date(event.gregorian);

    // console.log(viaTimestampValue);
    // console.log(viaGregorianDate);
    
  }

}
